import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchUserActionLogs = async (email) => {
  const token = localStorage.getItem("token");

  if (!email) throw new Error("email is required");

  const response = await axios.get(`${__API_URL__}/api/appiell/user_actions_logs/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
    params: { email },
  });

  const logs = response.data.logs || [];
  return logs.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
};

const useGetUserActionLogs = ({ email, enabled = true }) => {
  return useQuery({
    queryKey: ["user_action_logs", email],
    queryFn: () => fetchUserActionLogs(email),
    enabled: enabled && Boolean(email),
  });
};

export default useGetUserActionLogs;
